var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo, useState } from 'react';
import { useTheme } from 'styled-components';
var VGS_LIB_SCRIPT = 'https://js.verygoodvault.com/vgs-collect/2.18.5/vgs-collect.js';
export function useVGSScript() {
    var _a = useState(false), isLoaded = _a[0], scriptLoaded = _a[1];
    useEffect(function () {
        var script = document.createElement('script');
        script.src = VGS_LIB_SCRIPT;
        script.async = true;
        script.onload = function () { return scriptLoaded(true); };
        document.body.appendChild(script);
    }, []);
    return {
        vgsScriptLoaded: isLoaded,
    };
}
export function useVgsFormCss() {
    var _a = useTheme().colors, textBodyMain = _a.textBodyMain, textBodyPlaceholder = _a.textBodyPlaceholder, bordersDefault = _a.bordersDefault, warning = _a.warning;
    var fieldCss = useMemo(function () { return ({
        fontFamily: '"Inter", sans-serif',
        lineHeight: '24px',
        fontSize: '18px',
        fontWeight: '400',
        borderBottom: "1px solid ".concat(bordersDefault),
        color: textBodyMain,
        width: '100%',
        height: '48px',
        textTransform: 'uppercase',
        '&::placeholder': {
            color: textBodyPlaceholder,
        },
        '&:focus-visible': {
            borderColor: textBodyMain,
        },
        '&.invalid.touched.dirty': {
            borderColor: warning,
            color: warning,
        },
    }); }, [bordersDefault, textBodyMain, textBodyPlaceholder, warning]);
    var smallFieldCss = useMemo(function () { return (__assign(__assign({}, fieldCss), { width: '50%' })); }, [fieldCss]);
    return {
        fieldCss: fieldCss,
        smallFieldCss: smallFieldCss,
    };
}
